import styled from 'styled-components';
import { Panel } from '@/ui';
import { Icon } from '@/icons';
import { useSettingsSections } from '@/hooks';
import { sectionIcons } from '../sectionIcons';

const Wrap = styled(Panel)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 48px 24px;
`;

const Title = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.fontSize.lg};
  color: ${({ theme }) => theme.color.textPrimary};
`;

const Blurb = styled.p`
  margin: 0;
  max-width: 420px;
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;

const Soon = styled.span`
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: 500;
  color: ${({ theme }) => theme.color.textMuted};
`;

export function ComingSoonSection({ sectionId }: { sectionId: string }) {
  const { getSection } = useSettingsSections();
  const section = getSection(sectionId);
  const label = section?.label ?? 'Settings';
  return (
    <Wrap>
      <Icon name={sectionIcons[sectionId] ?? 'settings'} size={32} />
      <Title>{label}</Title>
      {section?.blurb && <Blurb>{section.blurb}</Blurb>}
      <Soon>Coming soon</Soon>
    </Wrap>
  );
}
